var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DropdownComp',{attrs:{"triggerClass":"rounded-md h-10","label":"","insideLabel":"Hub","options":_vm.hubs},model:{value:(_vm.hubSelected),callback:function ($$v) {_vm.hubSelected=$$v},expression:"hubSelected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }